import { PostData } from "@/types/types"

export const getAvailableLocales = (
  originalLocale: string,
  existingLocalizations: PostData[]
): string[] => {
  const allLocales = ["vi", "en", "cs"]
  const existingLocales = existingLocalizations.map((loc: PostData) => loc.attributes.locale)
  
  return allLocales.filter(loc => loc !== originalLocale && !existingLocales.includes(loc))
}

export const getTargetLocale = (
  originalLocale: string,
  existingLocalizations: PostData[]
): string => {
  const existingLocales = existingLocalizations.map((loc: PostData) => loc.attributes.locale)
  const allLocales = ["vi", "en", "cs"]
  
  const available = allLocales.filter(loc => loc !== originalLocale && !existingLocales.includes(loc))
  
  if (available.length > 0) {
    return available[0]
  }
  
  return originalLocale
}
/** Hậu tố locale ở cuối slug: "-vi" / "-en" / "-cs" (lặp được, vd "abc-en-cs"). */
const LOCALE_SUFFIX_RE = /(?:-(?:vi|en|cs))+$/i

/** Bỏ (các) hậu tố locale ở cuối slug: "abc-en" → "abc", "abc-en-cs" → "abc". */
export const stripLocaleSuffix = (slug: string): string => {
  const trimmed = (slug || "").trim()
  const stripped = trimmed.replace(LOCALE_SUFFIX_RE, "")
  // Slug chỉ gồm hậu tố (vd "en") thì giữ nguyên để không ra chuỗi rỗng.
  return stripped || trimmed
}

/**
 * Slug cho bản dịch: slug gốc (đã bỏ hậu tố locale cũ) + "-<locale>".
 * Dịch từ bài EN "abc-en" sang CS → "abc-cs" (trước đây ra "abc-en-cs").
 */
export const withLocaleSuffix = (slug: string, locale: string): string => {
  const base = stripLocaleSuffix(slug)
  return base ? `${base}-${locale}` : ""
}
